import { filter } from 'lodash';

const searchMarket = (markets, betType) => filter(markets,
  (market) => market.betType === betType)[0];

export default searchMarket;
